export const EXPORT_IMPORT_SOURCES = {
  EXPORT: 'meta_export',
  IMPORT: 'meta_import',
};

export const emptyLongDash = '—';
